import { useEffect } from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { toast } from "react-toastify";

export default function GlobalToastObserver() {
  const { "success-toast": successMessage, "info-toast": infoMessage } =
    useSearch({ from: "__root__" });
  const navigate = useNavigate();

  useEffect(() => {
    if (!successMessage) return;

    toast.success(successMessage);

    navigate({
      to: ".",
      search: (prev: Record<string, unknown>) => {
        const rest = { ...prev };
        delete rest["success-toast"];
        return rest;
      },
      replace: true,
    });
  }, [successMessage, navigate]);

  useEffect(() => {
    if (!infoMessage) return;

    toast.info(infoMessage);

    navigate({
      to: ".",
      search: (prev: Record<string, unknown>) => {
        const rest = { ...prev };
        delete rest["info-toast"];
        return rest;
      },
      replace: true,
    });
  }, [infoMessage, navigate]);

  return null;
}
